// extracted by mini-css-extract-plugin
module.exports = {"InputText":"styles_InputText__ps0HN","icon":"styles_icon__GqME9"};